/**
 * To access the nested property in an object safely
 * Usage Ex 1: User.address.line1 can be accessed safeGet(User, 'address.line1', 'default_value_if_not_present')
 * Ex2: User.address[2].line1 can be accessed safeGet(User,'address.2.line1','default_value_if_not_present')
 * @param { Source to look for the props} inputObject
 * @param { Props is a string seperated with . } props
 * @param { DefaultValue is returned if the key is not found by default set to false} defaultValue
 * @returns value of an object
 */
export const safeGet = (inputObject: any, props: string, defaultValue: any = false) => {
  return props.split('.').reduce((nestedObj, prop) => {
    const response = nestedObj && Object.keys(nestedObj).length > 0 && nestedObj[prop];
    return response || defaultValue;
  }, inputObject);
};

/**
 * Creates a deep clone of the provided value.
 *
 * @param {unknown} value - The value to be deep cloned.
 * @returns {unknown} A deep clone of the provided value.
 */
export const deepClone = (value: unknown) => {
  if (!value) {
    return value;
  }
  return JSON.parse(JSON.stringify(value));
};

/**
 * Delete orops from the given object
 * @param inputObject is having the key and value pair
 * @param propsList list of properties to exclude from the input object
 * @returns the object by removing the props from the input object
 */
export const omitPropsFromObj = (inputObject: any, propsList: string[]) => {
  const newObj = inputObject;
  if (!newObj || Object.keys(newObj).length === 0) {
    return newObj;
  }
  (propsList || []).forEach((key: string) => {
    if (key in newObj) {
      delete newObj[key];
    }
  });
  return newObj;
};
// grouping no of elements in given array
export const groupByItems = (data: any[], noOfItems: number) => {
  const resultObj = (data || []).reduce(
    (result: any[], _value: any, index: number, array: any[]) => {
      if (index % noOfItems === 0) result.push(array.slice(index, index + noOfItems));
      return result;
    },
    [],
  );

  return resultObj;
};
